module.exports = __webpack_public_path__ + "static/media/TB-303.e485e475.svg";